// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3jOGu","clinicsSelect":"TableHeading_clinicsSelect__24lyN"};